/* import __COLOCATED_TEMPLATE__ from './block-customer-from-early-stage-application.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();